<template>
  <slot v-if="disabled" v-bind="$attrs" />
  <span v-else v-bind="$attrs" :ref="triggerRef" class="s-tooltip">
    <slot />
    <Teleport :disabled="!teleportToBody" to="body">
      <span
        v-if="tooltip || slots.content"
        :id="id"
        :ref="popupRef"
        class="s-tooltip__popup"
        :class="{
          's-tooltip__popup--open': isOpen,
          's-tooltip__popup--dark': dark,
        }"
        role="tooltip"
      >
        <slot name="content">{{ tooltip }}</slot>
        <div :ref="arrowRef" class="s-tooltip__arrow" />
      </span>
    </Teleport>
  </span>
</template>

<script setup lang="ts">
import { useSlots } from "vue";

import * as useTooltip from "@/lib/components/logic/atoms/useTooltip";

const props = defineProps(useTooltip.props);
const slots = useSlots();
const {
  triggerRef,
  popupRef,
  arrowRef,
  tooltip,
  dark,
  teleportToBody,
  disabled,
  id,
  isOpen,
} = useTooltip.use(props);
</script>

<style lang="postcss">
.s-tooltip {
  @apply inline-flex;

  &__arrow {
    @apply absolute z-10 h-2 w-2 rotate-45 bg-white;
  }
  &__popup {
    @apply left-0 top-0 w-max-content max-w-64 rounded bg-white px-2 py-1 text-sm font-normal text-gray-800;

    @apply invisible absolute z-10 opacity-0;
    transition:
      opacity 200ms 0ms,
      visibility 0ms 200ms;
    filter: drop-shadow(0 1px 2px rgb(0 0 0 / 10%))
      drop-shadow(0 1px 1px rgb(0 0 0 / 6%));

    &--open {
      @apply visible opacity-100 transition-opacity;
    }

    /* Popup-scoped so styling survives teleporting the popup out of .s-tooltip */
    &--dark {
      @apply bg-gray-800 text-white;

      .s-tooltip__arrow {
        @apply bg-gray-800;
      }
    }
  }
}
</style>
